import { render, staticRenderFns } from "./AlarmasForm.vue?vue&type=template&id=a9e74a00&"
import script from "./AlarmasForm.vue?vue&type=script&lang=js&"
export * from "./AlarmasForm.vue?vue&type=script&lang=js&"
import style0 from "./AlarmasForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports